import { format, parseISO } from "date-fns";
import moment from 'moment-timezone';
import {
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBModal,
    MDBTypography
} from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Loader from "../components/Loader";
import { classCheckinsByGymID, getMembersbyGymid } from "../services/apiServices.js";
import calImg from "./../components/images/calendar.svg";
import { formatDate } from '../utils/DateFormat';
import { getClass, getSchedule, getStaffInfo } from "../services/classApiServices";
import { getClassBookingInfo } from "../services/memberApiServices";

function ClassCheckinReport() {
    const [ScheduleInfo, setScheduleInfo] = useState([]);
    const [Classes, setClasses] = useState([]);
    const [TrainerData, setTrainerData] = useState([]);
    const [ClassChecins, setClassChecins] = useState([])
    const [inputText, setInputText] = useState("");
    const [loading, setLoading] = useState(true);
    const [Memberdata, setMemberdata] = useState([]);
    const currentTime = new Date()
    const startOfMonth = new Date(currentTime);
    startOfMonth.setDate(1);
    startOfMonth.setHours(0, 0, 0, 0);
    const [basicModal, setBasicModal] = useState(null)
    const [checkinData, setcheckinData] = useState([])
    const [classNameFilter, setClassNameFilter] = useState("");
    const [dayFilter, setDayFilter] = useState("4");
    const [customdate, setCustomdate] = useState(dayFilter === "6");
    const [dateRange, setDateRange] = useState([startOfMonth, new Date()]);
    const [startDate, endDate] = dateRange;
    const [ScheduleInfos, setScheduleInfos] = useState(null);
    const [slotDetailsModal, setSlotDetailsModal] = useState(false)
    // Filter schedule data based on filters
    const [PolicyData, setPolicyData] = useState([]);

    // Add this useEffect to fetch cancellation policies
    useEffect(() => {
        const fetchCancellationPolicies = async () => {
            try {
                const response = await getClassBookingInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, "class");
                if (!response || response === "false") {
                    return;
                }
                const tempData = await response.json();
                setPolicyData(tempData?.cancelationinfo || []);
            } catch (error) {
                console.error("Error fetching cancellation policies:", error);
            }
        };

        if (localStorage.getItem("loggedUserInfo")) {
            fetchCancellationPolicies();
        }
    }, []);
    const getFilteredScheduleData = () => {
        let filteredData = ScheduleInfo;

        // Filter by class name
        if (classNameFilter) {
            filteredData = filteredData.filter(schedule => {
                const classDetails = Classes.find((obj) => obj._id == schedule.classid);
                return classDetails?.name?.toLowerCase().includes(classNameFilter.toLowerCase());
            });
        }

        // Filter by day filter
        if (dayFilter) {
            const currentTime = new Date();

            // Set time functions
            const setStartOfDay = (date) => {
                const newDate = new Date(date);
                newDate.setHours(0, 0, 0, 0);
                return newDate;
            };

            const setEndOfDay = (date) => {
                const newDate = new Date(date);
                newDate.setHours(23, 59, 59, 999);
                return newDate;
            };

            let startOfDate, endOfDate;

            switch (dayFilter) {
                case "1": // Today
                    startOfDate = setStartOfDay(currentTime);
                    endOfDate = setEndOfDay(currentTime);
                    break;
                case "2": // Yesterday
                    const yesterday = new Date(currentTime);
                    yesterday.setDate(currentTime.getDate() - 1);
                    startOfDate = setStartOfDay(yesterday);
                    endOfDate = setEndOfDay(yesterday);
                    break;
                case "3": // This Week
                    const startOfWeek = new Date(currentTime);
                    startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
                    startOfDate = setStartOfDay(startOfWeek);
                    const endOfWeek = new Date(startOfWeek);
                    endOfWeek.setDate(startOfWeek.getDate() + 6);
                    endOfDate = setEndOfDay(endOfWeek);
                    break;
                case "4": // This Month
                    const startOfMonth = new Date(currentTime.getFullYear(), currentTime.getMonth(), 1);
                    startOfDate = setStartOfDay(startOfMonth);
                    const endOfMonth = new Date(currentTime.getFullYear(), currentTime.getMonth() + 1, 0);
                    endOfDate = setEndOfDay(endOfMonth);
                    break;
                case "5": // This Year
                    const startOfYear = new Date(currentTime.getFullYear(), 0, 1);
                    startOfDate = setStartOfDay(startOfYear);
                    const endOfYear = new Date(currentTime.getFullYear(), 11, 31);
                    endOfDate = setEndOfDay(endOfYear);
                    break;
                case "6": // Custom
                    if (startDate && endDate) {
                        startOfDate = setStartOfDay(startDate);
                        endOfDate = setEndOfDay(endDate);
                    }
                    break;
                default:
                    // No filter applied
                    break;
            }

            if (startOfDate && endOfDate) {
                filteredData = filteredData.filter(schedule => {
                    const scheduleDate = new Date(schedule.startdate);
                    return scheduleDate >= startOfDate && scheduleDate <= endOfDate;
                });
            }
        }

        // Apply existing search filter
        if (inputText) {
            filteredData = filteredData.filter(schedule => {
                const classDetails = Classes.find((obj) => obj._id == schedule.classid);
                const trainerInfo = TrainerData.find((obj) => obj._id == schedule.trainerid);
                const className = classDetails?.name || "";
                const trainerName = (trainerInfo?.firstname + " " + trainerInfo?.lastname) || "";

                return trainerName.toLowerCase().includes(inputText.toLowerCase())
                // || className.toLowerCase().includes(inputText.toLowerCase())
            });
        }

        return filteredData;
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    const tmrowr = [];
    const filteredData = getFilteredScheduleData();
    const getCancellationPolicyForSlot = (slot) => {
        if (!slot || !PolicyData.length) return [];

        const policy = PolicyData.find(pol => pol?._id === slot.cancellationpolicyid);
        return policy?.cancelfee?.filter(fee => fee.checked) || [];
    };
    filteredData && filteredData.length > 0 && filteredData.map((itm, index) => {
        const scduleCheckins = ClassChecins.filter((obj) => obj.scheduleid == itm._id);
        const classDetails = Classes.find((obj) => obj._id == itm.classid);
        const trainerInfo = TrainerData.find((obj) => obj._id == itm.trainerid);
        const rarray = [];
        rarray.push(index + 1)
        rarray.push(classDetails?.name || "");
        rarray.push(formatDate(itm.startdate));
        rarray.push(
            new Date(itm.startdate).toLocaleTimeString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            })
        )
        rarray.push(
            new Date(itm.enddate).toLocaleTimeString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            })
        );
        rarray.push((trainerInfo?.firstname + " " + trainerInfo?.lastname) || " ");
        rarray.push(itm.bookedslots || 0)
        rarray.push(<label onClick={() => { setScheduleInfos({ schduleInfo: itm, classInfo: classDetails, trainerName: trainerInfo?.firstname + " " + trainerInfo?.lastname }); setcheckinData(scduleCheckins); setBasicModal((classDetails?.name + " - " + formatDate(itm.startdate)) || "Class Name") }}>{scduleCheckins?.length}</label>)
        tmrowr.push(rarray)
    })

    const basicData = {
        columns: ["S.no", 'Class Name', "Schedule Date", "Start Time", "End Time", "Trainer", "Slots Booked", "Total Check-in"],
        rows: tmrowr,
    };

    const checkinrow = [];

    checkinData && checkinData.length > 0 && checkinData.map((itm, index) => {
        let memberinfo = Memberdata.find((obj) => obj._id == itm.id);
        const rarray = [];
        rarray.push(index + 1)
        rarray.push(memberinfo?.mid);
        rarray.push((memberinfo?.fname + " " + memberinfo?.lname) || "");
        rarray.push(itm.membershipstatus === "1" ? "Active" : "Inactive");
        rarray.push(memberinfo?.number || "");
        rarray.push(
            new Date(itm.intime).toLocaleTimeString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            })
        );
        rarray.push(
            new Date(itm.outtime).toLocaleTimeString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            })
        );
        const intime = new Date(itm.intime);
        const outtime = new Date(itm.outtime);

        if (!isNaN(intime) && !isNaN(outtime)) {
            const timeDiff = Math.abs(outtime - intime);
            const hours = Math.floor(timeDiff / (60 * 60 * 1000));
            const minutes = Math.floor((timeDiff % (60 * 60 * 1000)) / (60 * 1000));


            rarray.push(`${hours.toString().padStart(2, '0')}: ${minutes.toString().padStart(2, '0')}`);

        } else {
            rarray.push("--");
        }

        checkinrow.push(rarray)
    })

    const basicData2 = {
        columns: ["S.no", 'Member Id', 'Member Name', 'Status', "Number", "Check-In", 'Check-Out', "Hours Spent"],
        rows: checkinrow,
    }

    useEffect(() => {
        setCustomdate(dayFilter === "6" ? true : false);
    }, [dayFilter]);

    const getDates = (update) => {
        setDateRange(update);
    };
    const getRecurrenceText = (slot) => {
        if (!slot) return "--";

        const startMoment = moment(slot?.startdate);
        const endMoment = moment(slot?.enddate);
        let startdate = startMoment.format("hh:mm A");
        let enddate = endMoment.format("hh:mm A");

        const recurrence = slot?.recurrence || {};
        const recurrencetype = recurrence?.recurrencetype;

        const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
        const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        let recurrenceText = "";

        if (recurrencetype === "monthly") {
            let weeks = recurrence.value || [];
            let days = recurrence.subvalue || [];

            const allWeeks = weeks.includes(-1);
            const allDays = days.includes(-1);

            const weekText = allWeeks
                ? "every week"
                : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if ((allWeeks || weeks.length) && (allDays || days.length)) {
                if (allWeeks) {
                    recurrenceText = `Every week on ${dayText} at ${startdate} - ${enddate}`;
                } else {
                    recurrenceText = `Every ${weekText} of the month on ${dayText} at ${startdate} - ${enddate}`;
                }
            }
        } else if (recurrencetype === "weekly") {
            let days = recurrence.value || [];

            const allDays = days.includes(-1);

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if (days.length || allDays) {
                recurrenceText = `Every week on ${dayText} at ${startdate} - ${enddate}`;
            }
        } else {
            // For onetime or unknown types - use the timeslot directly
            recurrenceText = `${startdate} - ${enddate}` || "--";
        }

        return recurrenceText || `${startdate} - ${enddate}` || "--";
    };
    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="form-control select-input placeholder-active me-3 shadow-1 form-selectMobile">
                {value === "" ? "Custom Range" : value}
                &nbsp;
                <img
                    src={calImg}
                    onClick={onClick}
                    ref={ref}
                    alt="custom Range"
                    title="Select Custom Range"
                />
            </span>
        </>
    ));

    useEffect(() => {
        const fetchData = async () => {
            const response = await getSchedule(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const scheduleinfo = await response.json();
            const currentDate = new Date();

            scheduleinfo.sort((a, b) => new Date(b.startdate) - new Date(a.startdate))
            console.log(scheduleinfo, 'sssssssssss');
            
            const filteredSchedules = (scheduleinfo || []).filter(schedule => {
                const startDate = new Date(schedule?.startdate);
                const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

                const diffInMs = startDate - currentDate;
                const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

                const includeEvent = Math.abs(diffInDays) <= visibledaysbefore;

                return includeEvent;
            });
            setScheduleInfo(filteredSchedules);
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
            const response = await classCheckinsByGymID(gymid, { gymid: gymid });
            if (!response || response === "false") {
                return;
            }
            const classCheckIn_Info = await response.json();

            console.log(classCheckIn_Info, '123456');
            setClassChecins(classCheckIn_Info);
            setLoading(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
            const response = await getMembersbyGymid({ gymid: gymid });
            if (!response || response === "false") {
                return;
            }
            const memberdata = await response.json();

            console.log(memberdata, 'memberdata');
            setMemberdata(memberdata);
            setLoading(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getClass(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const classinfo = await response.json();

            console.log(classinfo, 'classsssssssss');
            setClasses(classinfo);
        }
        const fetchStaffData = async () => {
            const trainerres = await getStaffInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!trainerres || trainerres === "false") {
                return;
            }
            const trainerinfo = await trainerres.json();

            console.log(trainerinfo, 'trainerinfo');
            setTrainerData(trainerinfo)

        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData();
            fetchStaffData();
        }
    }, [])
    return (
        <>
            {<div className="">

                <div className="d-flex flex-wrap" >

                    <div className="gym-section w-100-mobile">
                        <label className="fw-bold">Search: </label>
                        <div>
                            <input
                                type="text"
                                className="form-control select-input placeholder-active me-3 shadow-1  "
                                placeholder="Search by Trainer"
                                value={inputText}
                                onChange={(e) => setInputText(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Class Name Filter */}
                    <div className="gym-section w-100-mobile ms-3">
                        <label className="fw-bold">Class Name: </label>
                        <div>
                            <select
                                className="form-control select-input form-select placeholder-active me-3 shadow-1 "
                                onChange={(e) => setClassNameFilter(e.target.value)}
                                value={classNameFilter}
                            >
                                <option value="">All Classes</option>
                                {Classes.map((classItem) => (
                                    <option key={classItem._id} value={classItem.name}>
                                        {classItem.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Day Filter - Replaced Schedule Date Filter */}
                    <div className="gym-section w-100-mobile ms-3">
                        <label className="fw-bold"> Days: </label>
                        <div>
                            <select
                                className="form-control select-input form-select placeholder-active me-3 shadow-1 "
                                onChange={(e) => setDayFilter(e.target.value)}
                                value={dayFilter}
                            >
                                <option value="">All</option>
                                <option value="1">Today</option>
                                <option value="2">Yesterday</option>
                                <option value="3">This Week</option>
                                <option value="4">This Month</option>
                                <option value="5">This Year</option>
                                <option value="6">Custom</option>
                            </select>
                        </div>
                    </div>

                    {customdate && (
                        <div className="gym-section w-100-mobile ms-3">
                            <label className="fw-bold"> Select Custom Date: </label>
                            <DatePicker
                                dateFormat={"d/M/yyyy"}
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={getDates}
                                isClearable={false}
                                customInput={<CalenderInput />}
                            />
                        </div>
                    )}
                </div>
                {loading ? <h4><Loader /></h4> :
                    <div className="datatable reports">
                        <MDBDatatable fixedHeader className="mt-4 large-scrool-table" data={basicData} entries={50} />
                    </div>
                }
                {basicModal &&
                    <MDBModal open={basicModal} >
                        <MDBModalDialog size="xl">
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle><div className="d-flex"><div>{basicModal}</div></div></MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={() => { setBasicModal(null) }}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <div className="text-end mb-2 pt-0 mt-0">
                                        <MDBBtn className="ms-2" onClick={() => setSlotDetailsModal(true)}>Event Details</MDBBtn>
                                    </div>
                                    <div className="trainerMemberSummeryDataTable">
                                        <MDBDatatable entries={25} data={basicData2} />
                                    </div>
                                </MDBModalBody>
                                <MDBModalFooter className="pe-4 pb-3">
                                    <MDBBtn className="ms-2" color="secondary" onClick={() => setBasicModal(null)}>Close</MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>}

                <MDBModal open={slotDetailsModal} onClose={() => setSlotDetailsModal(false)} tabIndex='-1'>
                    <MDBModalDialog size="lg">
                        <MDBModalContent style={{ maxHeight: '70%' }}>
                            <MDBModalHeader>
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <MDBTypography tag='h6' className="m-0 p-0">
                                        {ScheduleInfos?.classInfo?.name}
                                    </MDBTypography>
                                    <div className='d-flex align-items-center'>
                                        <MDBBtn className='btn-close ms-3' color='none' onClick={() => setSlotDetailsModal(false)}></MDBBtn>
                                    </div>
                                </div>
                            </MDBModalHeader>
                            <MDBModalBody className='p-4'>
                                <table className="table table-striped table-bordered compressed-table mb-0">
                                    <tbody>
                                        <tr>
                                            <td width="150px">Date</td>
                                            <td>{new Date(ScheduleInfos?.schduleInfo?.startdate).toLocaleDateString('en-US', {
                                                weekday: 'long',
                                                month: 'short',
                                                day: 'numeric',
                                                year: "numeric"
                                            })}</td>
                                        </tr>
                                        <tr>
                                            <td width="150px">Time</td>
                                            <td>{getRecurrenceText(ScheduleInfos?.schduleInfo)}</td>
                                        </tr>
                                        <tr>
                                            <td>Host</td>
                                            <td>{ScheduleInfos?.trainerName || "Unknown Name"}</td>
                                        </tr>
                                        <tr>
                                            <td>Slots</td>
                                            <td>
                                                {ScheduleInfos?.schduleInfo?.bookedslots || 0}/{ScheduleInfos?.schduleInfo?.totalslots || 0} Booked
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Location</td>
                                            <td>{ScheduleInfos?.schduleInfo?.location}</td>
                                        </tr>
                                        <tr>
                                            <td>Show Before (Days)</td>
                                            <td>{ScheduleInfos?.schduleInfo?.visibledaysbefore}</td>
                                        </tr>
                                        <tr>
                                            <td>Session Type</td>
                                            <td>{ScheduleInfos?.schduleInfo?.isprivate ? "Private" : "Public"}</td>
                                        </tr>
                                        <tr>
                                            <td>Cancellation Policy</td>
                                            <td>
                                                <div className='mb-0 text-wrap'>
                                                    {getCancellationPolicyForSlot(ScheduleInfos?.schduleInfo).length > 0 ? (
                                                        getCancellationPolicyForSlot(ScheduleInfos?.schduleInfo).map((element, index) => (
                                                            <p key={index} className='mb-1 text-wrap'>
                                                                {element.days} day(s) - {element.feevalue}% fee
                                                            </p>
                                                        ))
                                                    ) : (
                                                        <p className="m-0">No cancellation policy available</p>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Description</td>
                                            <td>
                                                <p className='mb-0 ms-2'
                                                    title={stripHtmlTags(ScheduleInfos?.classInfo?.description ? ScheduleInfos?.classInfo.description : "--")}
                                                    dangerouslySetInnerHTML={{
                                                        __html: ScheduleInfos?.classInfo?.description ? ScheduleInfos?.classInfo?.description : "--",
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </MDBModalBody>
                            <MDBModalFooter className="px-3 pb-2">
                                <MDBBtn color='secondary' onClick={() => setSlotDetailsModal(false)}>
                                    Close
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            </div >}
        </>
    )
}

export default ClassCheckinReport;